const PaginationControls = ({
  totalCount,
  currentPage,
  pageSize,
  pageSizeOptions,
  onPageChange,
  onPageSizeChange,
}) => {
  if (totalCount <= 0) return null;

  const totalPages = Math.ceil(totalCount / pageSize);

  const pages = [];
  for (let i = 1; i <= totalPages; i++) {
    if (i === 1 || i === totalPages || (i >= currentPage - 2 && i <= currentPage + 2)) {
      pages.push(i);
    }
  }

  const pageItems = [];
  let prev;
  for (const p of pages) {
    if (prev && p - prev > 1) {
      if (p - prev === 2) {
        const missing = prev + 1;
        pageItems.push(
          <li key={missing} className={`page-item${missing === currentPage ? " active" : ""}`}>
            <button
              className="page-link"
              onClick={() => onPageChange(missing)}
              style={missing === currentPage ? { backgroundColor: "#005A9A", color: "#fff", borderColor: "#005A9A" } : {}}
            >
              {missing}
            </button>
          </li>
        );
      } else {
        pageItems.push(
          <li key={`ellipsis-${p}`} className="page-item disabled">
            <span className="page-link">…</span>
          </li>
        );
      }
    }
    pageItems.push(
      <li key={p} className={`page-item${p === currentPage ? " active" : ""}`}>
        <button
          className="page-link"
          onClick={() => onPageChange(p)}
          style={p === currentPage ? { backgroundColor: "#005A9A", color: "#fff", borderColor: "#005A9A" } : {}}
        >
          {p}
        </button>
      </li>
    );
    prev = p;
  }

  return (
    <div className="d-flex align-items-center justify-content-between w-100 mt-2 mb-3">
      <div className="d-flex align-items-center" style={{ marginLeft: "0.5cm" }}>
        <small className="mr-2">Righe per pagina:</small>
        <select
          className="page-size-select"
          style={{ width: "80px" }}
          value={pageSize}
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
        >
          {pageSizeOptions.map((opt) => (
            <option key={opt} value={opt}>{opt}</option>
          ))}
        </select>
        <small className="ml-3">
          {(currentPage - 1) * pageSize + 1}–{Math.min(currentPage * pageSize, totalCount)} di {totalCount}
        </small>
      </div>
      <nav>
        <ul className="pagination mb-0">
          <li className={`page-item${currentPage === 1 ? " disabled" : ""}`}>
            <button className="page-link" onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1}>
              &laquo;
            </button>
          </li>
          {pageItems}
          <li className={`page-item${currentPage === totalPages ? " disabled" : ""}`}>
            <button className="page-link" onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages}>
              &raquo;
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default PaginationControls;
